/**
 * @desc service that provides common functionalite for full page charts
 * namely: Inventory Burnoff and POs to Action: 12 months
 */

(function() {
	'use strict';

	angular
		.module('app.core')
		.service('fullPageChart', fullPageChart);

	function fullPageChart(oldNavMargin, oldNavMarginCollapsed) {
		var service = {
			resizeChart: resizeChart,
			roundRangeValues: roundRangeValues,
			paintRect: paintRect
		};
		return service;

		function resizeChart(chartContainerId, selfContained) {
			var chartElement = jQuery('#' + chartContainerId);
			var isWidget = chartElement.parents('adf-widget-content').length > 0;
			var hasEndOfLifeBanner = jQuery('.browserIE11EndOfLifeBanner.show').length !== 0;
			var isWideNewNav = jQuery('#sub-navigation').length === 1;
			var isLinkBack = jQuery('link-back-to-reports').length !== 0;
			var isOriginatedFrom = jQuery('.originated-from-container').length !== 0;
			var isInWidget = jQuery('adf-widget-content').length > 0;
			var navOffset = 120;
			if (isWideNewNav) {
				navOffset = 230;
			}
			

			var interactiveHistoryBannerHeight = jQuery('#interactive-history-banner > div').length ? 60 : 0;
			var newNavTopBanner = jQuery('#new-nav-opt-banner').height() || 0;

			var navHeight = 0;
			if (hasEndOfLifeBanner) {
				navHeight += 60;
			}
			if (isLinkBack) {
				navHeight += 21;
			}
			if (isOriginatedFrom) {
				navHeight += 21;
			}

			if(isInWidget) {
				navHeight += 40;
			}

			var newHeight = selfContained ? chartElement.height() : jQuery(window).height() - navHeight - 41 - 40 - 42 - 8 - interactiveHistoryBannerHeight - newNavTopBanner;
			var paddingOffset = 32;
			var widgetOffset = 0;
			if (isWidget) {
				newHeight -= 60;
				widgetOffset = 20;
			}
			chartElement.css('width', (jQuery('.embeddedBody').width()) + 'px');
			chartElement.css('height', newHeight + 'px');
			chartElement.css('max-height', newHeight + 'px');
			var width = jQuery('.row').width() - jQuery('.filters.dropdown').width() -
				jQuery('.searchBlock').width();
			var width2 = jQuery('.row').width() - 40;
			var totalFilters = jQuery('.currentFilters').length;
			var minWidthOfFilters = totalFilters * 54 + jQuery('.filters.dropdown').width();
			var totalFilterWidth = 0;
			jQuery('.row .currentFilters').each(function(index) {
				totalFilterWidth += parseInt(jQuery(this).width());
			});
			width2 = width2 - totalFilterWidth;
			if (width2 < minWidthOfFilters) {
				jQuery('.filtersContainer').css('height', 'auto');
				jQuery('.filtersContainer .row').css('height', 'auto');
				jQuery('.filterRowWidthAdjuster').css('width', width);
			} else {
				if (!(jQuery('.extraText') && jQuery('.extraText').length)) {
					jQuery('.filtersContainer .row').css('height', 44);
					jQuery('.filtersContainer').css('height', 44);
				} else {
					jQuery('.filtersContainer').css('height', 0);
				}

				jQuery('.filterRowWidthAdjuster').css('width', '100%');
			}
			var maxWidth = width / totalFilters - 16 > 400 ? 400 : width / totalFilters - 16;
			jQuery('.currentFilters').css('maxWidth', maxWidth);
			jQuery('.currentFilters .filterEdit').css('maxWidth', maxWidth);

			return newHeight;
		}

		function roundRangeValues(range, ticks, first) {
			// will break if same value, so spread values out
			if (range.min === range.max) {
				if (range.min === 0) {
					range.max = 1;
				}
				range.max *= 1.1;
				range.min *= 0.9;
			}
			var min = range.min;
			var max = range.max;
			var diff = range.max - range.min;

			var unroundedTickSize = diff / (ticks - 1);
			var log10TickSize = Math.log(unroundedTickSize) / Math.log(10);
			var x = Math.ceil(log10TickSize - 1);
			var pow10x = Math.pow(10, x);
			var roundedTickRange = Math.ceil(unroundedTickSize / pow10x * 2) / 2 * pow10x;
			if (roundedTickRange < 0.01 * max) {
				roundedTickRange = 0.01 * max;
			}

			if (first) {
				range.min = roundedTickRange * Math.floor(min / roundedTickRange);
			}
			range.max = roundedTickRange * (ticks - 1) + range.min;
			// correct for floating point addition
			if (range.max > max * 0.9999999 && range.max < max * 1.000001) {
				range.max = max;
			}
			if (range.max < max) {
				range = roundRangeValues({ 'min': range.min, 'max': max }, ticks);
			}
			return range;
		}

		function paintRect(parentElem, color1, color2) {
			var axisYParent = jQuery(parentElem).find('.c3-axis-y')[0];
			var axisY2Parent = jQuery(parentElem).find('.c3-axis-y2')[0];
			var axisYTopTick;
			var axisY2TopTick;
			var childTicks;
			if (axisYParent) {
				childTicks = jQuery(axisYParent).find('.tick');
				if (childTicks && childTicks.length) {
					axisYTopTick = childTicks[childTicks.length - 1];
				}
			}
			if (axisY2Parent) {
				childTicks = jQuery(axisY2Parent).find('.tick');
				if (childTicks && childTicks.length) {
					axisY2TopTick = childTicks[childTicks.length - 1];
				}
			}
			if (axisYTopTick && axisY2TopTick) {
				var squareY, squareY2;
				var rectOneX = -30;
				var rectTwoX = 20;
				var rectSide = 14;
				squareY = makeSVG('rect', { x: rectOneX, y: 10, width: rectSide, height: rectSide, fill: color1 });
				squareY2 = makeSVG('rect', { x: rectTwoX, y: 10, width: rectSide, height: rectSide, fill: color2 });
				jQuery(axisYTopTick).prepend(squareY);
				jQuery(axisY2TopTick).prepend(squareY2);
			}
		}
	}
})();
